const scrollWatcher = (classSelector) => {
  if (!classSelector) return
  let topScroll = document.documentElement?.scrollTop || 0;

  const findElement = document.querySelector(`.${classSelector}`);
  if (!findElement) return

  let getElem = findElement.getBoundingClientRect();
  if (topScroll >= (getElem.top + topScroll - window.innerHeight / 3 - 170 )) {
    return true;
  }
}

export {
  scrollWatcher
}
